import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useLang } from "@/i18n";
import { scrollToSection } from "./scroll";

export default function BackToTop() {
  const { isFr } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.button
          initial={{ opacity: 0, scale: 0.6, y: 12 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.6, y: 12 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          whileHover={{ scale: 1.08 }}
          whileTap={{ scale: 0.94 }}
          onClick={() => scrollToSection("accueil")}
          aria-label={isFr ? "Remonter en haut de page" : "Back to top"}
          data-testid="back-to-top-button"
          className="fixed bottom-[88px] right-5 sm:bottom-[96px] sm:right-7 z-[60] w-14 h-14 rounded-full glass text-bone hover:text-gold border gold-hairline flex items-center justify-center"
        >
          <span className="font-mono text-xl leading-none">↑</span>
        </motion.button>
      )}
    </AnimatePresence>
  );
}
